import '../App.css';
import React,  {Alert,Component,PointerEvent} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade,EffectCreative } from 'swiper';
import { Pagination, Navigation,Autoplay } from "swiper";
import { useRef, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import "swiper/css/effect-creative";
import { Nav,Navbar,Form,Button,Container,Row,Col,NavDropdown,Card,Modal} from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import MailIcon from '@material-ui/icons/Mail';
import CallIcon from '@material-ui/icons/Call';
import HouseIcon from '@material-ui/icons/House';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { BrowserRouter as Router, Switch, Route, Link,Redirect,HashRouter } from 'react-router-dom';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Carousel from 'react-bootstrap/Carousel';
import { BrowserView, MobileView, isBrowser, isMobile} from "react-device-detect";
import queryString from 'query-string';
import { Rating } from 'react-simple-star-rating'
import videoexoticmadagascar from '../assets/EXOTIC_MADAGASCAR_HOME.mp4';
import VideoBackground from './Videobackground';
import ReactPlayer from 'react-player';
import loader_exotic from './loader_exotic.svg';
import logo_exotic from './logo_exotic_400.png';
import ATTAMember_opt2 from './ATTAMember_opt2.jpeg';
import ATTAMember_opt3 from './ATTAMember_opt3.jpeg';
import Aboutus_background from './aboutus.jpg';
;

const idvideoexotic = "xTe4j7126l4";

class Accueil extends Component{

  constructor(props) {
  super(props);
    this.state = {
      loaddata : true,
      show: false,
      setShow: false,
      isModalVisible: false,
      isModalloderVisible : true,
      accueiltitre: '',
      accueilimage: '',
      touteslesarticles: [],
      touteslestours: [],
      listimage:[],
      idtourselect:0,
      title:'',
      description:'',
      roadmap:'',
      extensionfile:'',
      touteslesaccueil: [],
      touteslesgallery: [],
      gallery: [],
      allopinionuser:[],
      width: 0,
      height: 0,
      scrollpage:0,
      ratingvalue:5,
      ismodalinscription:false,
      avisdescription:'',
      screennwidth:0,
      screenheight:0,
      isLoadingmovie: true,
      hoveredIdImage:0,
      hoveredLinkImage:"",
      Fullscreenview: false,
      orientation:
        window.innerWidth > window.innerHeight
          ? "landscape"
          : "portrait",
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      
  }

  handleResize = () => {
    this.setState({
      orientation:
        window.innerWidth > window.innerHeight
          ? "landscape"
          : "portrait",
    });
     
  };
  
  async componentDidMount() {

    {/*//liste des articles
    const response = await fetch('https://mada-phototours.com/wbs/listtours/alltours.php');
    const data = await response.json();
  this.setState({ touteslesarticles: data})*/} 

      this.setState({
        screennwidth:window.innerWidth,
        screenheight:window.innerHeight,
      })
    
    //liste des accueils
    const responseaccueil = await fetch('https://exotic-madagascar.com/wbs/accueil/allaccueil.php');
    const dataaccueil = await responseaccueil.json();
    this.setState({ touteslesaccueil: dataaccueil})
    
    //liste des gallery
    const responsegallery= await fetch('https://exotic-madagascar.com/wbs/gallery/allgallery.php');
    const datagallery = await responsegallery.json();
    this.setState({ touteslesgallery: datagallery}) 
  
    this.refreshgallery(datagallery) 

    //liste des tours
    const responsetours = await fetch('https://exotic-madagascar.com/wbs/tours/alltours.php');
    const datatours = await responsetours.json();
    this.setState({ touteslestours: datatours}) 
    
    

    //liste opinion
    const allopinion = await fetch('https://exotic-madagascar.com/wbs/users/selectopinion.php');
    const dataopinion = await allopinion.json();
    if(JSON.stringify(dataopinion).replace(/\"/g, "") !== '0'){
      this.setState({ allopinionuser: dataopinion})
    }
    
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.updateWindowDimensions);
      
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight, scrollpage: window.scrollY });
  }

  scrolltop(){
    window.scrollTo(0, 0)
  }

  handleLoaded = () => {
    this.setState({ isLoadingmovie: false });
  };

  refreshgallery(datagallery){
    
    datagallery.forEach((item)=>{
      this.state.gallery.push({ idgallery: item.idgallery, original: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage, thumbnail: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage});
    })

    /*for (let i = 1; i < 21; i++) {

      if(i<10){
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg'});
      }else{
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg'});
      }
      
    }*/

  }

  reservation = (typetours) => { 

    window.location.href = "mailto:contact@exotic-madagascar.mg?Subject=Booking to " + typetours

  }

  navigateto = (linktonavigate) => { 

    window.location.href = linktonavigate

  }

  async selecttours(idtours,tourstitle,toursdescription,toursroadmap,extensionfile){

    this.setState({
      idtourselect: idtours,
      title:tourstitle,
      description:toursdescription,
      roadmap:toursroadmap,
      extensionimg: extensionfile,
      isModalVisible:true
    })
  
    const response = await fetch('https://exotic-madagascar.com/wbs/tours/gallerytours/selectimagetours.php',{                  
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({
            idtrs:idtours
          })});
    const data = await response.json();
  
    this.setState({
      listimage:data,
    })
  
  }

  addopinion(){

    if(this.state.nom.length == 0 && this.state.prenoms.length == 0) {

      alert("Please add your name or lastname.");
            
      return;

    }

    if (typeof(this.state.mail) == 'undefined') {

      alert("Please add your mail address.");
            
      return;

    }

    if (typeof(this.state.mail) !== undefined) {

        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!pattern.test(this.state.mail)) {

            alert("Please write an exact mail address.");
            
            return;

        }
          
    }

    if(this.state.motdepasse.length < 8) {

      alert("Password must be minimum 8 characters.");
            
      return;

    }

    if(this.state.avisdescription.length == 0) {

      alert("Please add your rating description.");
            
      return;

    }

    fetch(`https://exotic-madagascar.com/wbs/users/addopinion.php`,{                  
            
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({

            Nom: this.state.nom,
            Prenoms: this.state.prenoms,
            Email:this.state.mail,
            Motdepasse:this.state.motdepasse,
            avis : this.state.ratingvalue,
            descriptionavis : this.state.avisdescription,

          })

      })

      .then(response => response.json())
      .then(data => {

        if(JSON.stringify(data).replace(/\"/g, "") === 'User exist'){
          this.setState({ errorform: true, errormessage: 'User is exist.' });

          return;

        }

        if(JSON.stringify(data).replace(/\"/g, "") === 'Error insert'){
          this.setState({ errorform: true, errormessage: 'Error on server. Please repeat again.' });

          return;

        }

    
        if(JSON.stringify(data).replace(/\"/g, "") !== '0'){
          
          this.setState({ allopinionuser: data})
          
          this.setState({
            errorform: false,
            errormessage:'',
            nom:'',
            prenoms:'',
            mail:'',
            motdepasse:'',
            avis : "",
            ratingvalue:5,
            descriptionavis : "",
            avisdescription : "",
            ismodalinscription:false,
            //signin : true,
          });   
          
         
          alert("Your registration has been completed add your opinion has been add. You can log in to edit your profil.");

        }            
                  
      })

      .catch(error => {
            alert(error);
            this.setState({ tokenuser: error});
      });  

  }
  

  handlePointerMove = (value, index) => {
    this.setState({ ratingvalue: value}) 
  }

 

  render() {

      const onPointerMove = (value,index) => this.handlePointerMove(value, index);

        return (
    
              <div style={{marginTop:"80px"}}>
                
                {/*
                <div id="accueil">
            
                <Swiper

                    direction={"horizontal"}
                    spaceBetween={0}
                    centeredSlides={true}
                    autoplay={{
                      delay: 4000,
                      disableOnInteraction: false,
                    }}
                    effect="fade"
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                    modules={[Autoplay, Pagination, Navigation,EffectFade]}
                    className="swiper"
                    mousewheel={false}
                    Mousewheel={false}
                    mousewheelControl={false}
                    keyboardControl={true}
                    Scrollbar={false}
                    noSwiping={true}
                    onlyExternal={true}
                    allowTouchMove={false}
                    speed={4000}
                    >

                    {this.state.touteslesaccueil.map((acc) => {
                        return (

                            <div style={{margin:"20px"}}>

                              
                                  <SwiperSlide>
                                    <Fade delay={7000}>
                                    <div style={{backgroundImage: "url(" + process.env.PUBLIC_URL + './images/accueil/' + acc.idaccueil + '.' + acc.extensionimage + ")", backgroundPosition: 'center',  backgroundSize: isBrowser ? 'cover': 'contain',  backgroundRepeat: 'no-repeat', width:'100%', height: isBrowser? '100vh':'23rem'}}>
                                      <div style={{marginTop:isBrowser?'20%':'30%', marginLeft:'5%'}}>

                                        <Fade delay={1000}>
                                          <p style={{fontSize: isBrowser?'1.5rem':'1.2rem', color: 'white'}} className="textombrenoir">{acc.titre}</p>
                                        </Fade>

                                        <Fade delay={1000}>
                                          <p style={{fontSize: isBrowser?'3rem':'1.5rem', color: 'white', fontWeight:'bold'}} className="textombrenoir">{acc.description}</p>
                                        </Fade>

                                      </div>
                                      

                                    </div>
                                    </Fade>
                                    </SwiperSlide>
                                
                            </div>

                        );
                    })}

                    </Swiper> 
                </div>

                */}
              
                <BrowserView>
                  <div className="video-background" style={{width:this.state.screennwidth, height:this.state.screenheight-70}}>

                     {/* LOADER */}

                      {this.state.isLoadingmovie  === true ?

                        <div className="d-flex align-items-center justify-content-center vh-100">
                          <img src={loader_exotic} alt="Exotic Madagascar"  style={{width:"100px", height:"100px", marginTop:"-10%"}}/>
                        </div>

                        :

                        null

                      }

                    <video
                      
                        style={{
                          width: "100%",
                          height: "100%",
                          opacity: this.state.isLoadingmovie ===true ? 0 : 1,
                          transition: "opacity 0.5s ease",
                          objectFit: "fill", 
                          overflow: "hidden"
                        }}
                        autoPlay
                        fullscreen
                        loop
                        muted
                        playsInline
                        //onLoadedData={this.handleLoaded}
                        onCanPlayThrough={this.handleLoaded}
                      >

                      <source src={videoexoticmadagascar} type="video/mp4" />

                    </video>

                    <div className="d-flex flex-row justify-content-center" style={{zIndex:99999, marginTop:"-10%"}}>

                      <Fade left>
                        <div className='button_aboutus textombrenoir' onClick={() => this.navigateto("/Aboutus")}>

                            <p style={{fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>About us</p>
                          
                        </div>
                      </Fade>

                      <Fade right>
                        <div className='button_aboutus textombrenoir' onClick={() => this.navigateto("/Services")}>
                          
                            <p style={{fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>Our services</p>
                                                    
                        </div>
                      </Fade>

                    </div>

                    <div className="d-flex flex-row justify-content-center" style={{zIndex:99999, marginTop:"-30%"}}>

                      <Fade bottom>
                        <div className='button_tours textombrenoir' onClick={() => this.navigateto("/Tours")}>

                            <p style={{fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>Tours</p>
                          
                        </div>
                      </Fade>

                    </div>

                                        
                  </div>
                  

                </BrowserView>

                <MobileView>

                  <div className="video-background" style={{width:this.state.screennwidth, height:this.state.screenheight/2.8}}>

                    {this.state.isLoadingmovie  === true ?

                        <div className="d-flex align-items-center justify-content-center vh-100">
                          <img src={loader_exotic} alt="Exotic Madagascar"  style={{width:"100px", height:"100px", marginTop:"-10%"}}/>
                        </div>

                        :

                        null

                      }

                    <video
                      
                        style={{
                          width: "100%",
                          height: "100%",
                          opacity: this.state.isLoadingmovie ===true ? 0 : 1,
                          transition: "opacity 0.5s ease",
                          objectFit: "fill", 
                          overflow: "hidden"
                        }}
                        autoPlay
                        fullscreen
                        loop
                        muted
                        playsInline
                        //onLoadedData={this.handleLoaded}
                        onCanPlayThrough={this.handleLoaded}
                      >

                      <source src={videoexoticmadagascar} type="video/mp4" />

                    </video>

                     <div className="d-flex flex-row justify-content-center" style={{zIndex:99999, marginTop:"-20%"}}>

                        <Fade left>
                          <div className='button_aboutus_mobile textombrenoir' onClick={() => this.navigateto("/Aboutus")}>

                              <p style={{fontWeight:"bold", textAlign:'center', marginTop:'0px'}}>About us</p>
                            
                          </div>
                        </Fade>

                        <Fade right>
                          <div className='button_aboutus_mobile textombrenoir' onClick={() => this.navigateto("/Services")}>
                            
                              <p style={{fontWeight:"bold", textAlign:'center', marginTop:'0px'}}>Our services</p>
                                                      
                          </div>
                        </Fade>

                      </div>

                      <div className="d-flex flex-row justify-content-center" style={{zIndex:99999, marginTop:"40px"}}>

                        <Fade bottom>
                          <div className='button_aboutus_mobile textombrenoir' onClick={() => this.navigateto("/Tours")}>

                              <p style={{fontWeight:"bold", textAlign:'center', marginTop:'0px'}}>Tours</p>
                            
                          </div>
                        </Fade>

                      </div>

                  </div>

                </MobileView>


                

                <div >

                  {/* 
                  <Fade bottom>
                    <div className='align-items-center'>                         
                        <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>About us</p>

                    </div>
                  </Fade>
                  */}

                

                 

                

                <BrowserView>
                <Modal
                        size='xl'
                        show={this.state.isModalVisible}
                        onHide={ () => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'', roadmap:'', extensionimg: '',listimage:[]})}
                        dialogClassName="modal-dialog"
                        aria-labelledby="example-custom-modal-styling-title" centered
                    >
                    
                    <Modal.Body>
                        
                        <div className="d-flex flex-row">

                          {this.state.listimage.length>0 ?

                              <Carousel >

                              {this.state.listimage.map((lst) => {

                              return (

                                    <Carousel.Item key={lst.idimagestours} interval={3000}>
                                  
                                      <img
                                        style={{width:"500px",height:"500px", marginTop:"0px", borderRadius:"10px"}}
                                        src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + lst.idimagestours + '.' + lst.extensionimage}
                                      />
                                                                                  
                                    </Carousel.Item>

                                );
                              })} 

                              </Carousel>

                            :

                            <img
                                style={{width:"500px",height:"500px", marginTop:"0px", borderRadius:"10px"}}
                                src={process.env.PUBLIC_URL + './images/tours/' + this.state.idtourselect + '.' + this.state.extensionimg}
                              />

                          }
                            
                            
                                <div className="d-flex flex-column" style={{margin:"20px"}}>
                                    
                                    <div className="d-flex flex-column">
                                        <p style={{fontWeight:"bold", textAlign:'center'}}>{this.state.title}&nbsp;</p>
                                        <p style={{maxHeight:"12rem",overflowX:"auto"}}>{this.state.description}</p>
                                    </div>
                                    
                                <div>
                                    <div className="d-flex flex-column" style={{overflow:"auto", height:'260px', width:'600px',maxHeight:"12rem",overflowX:"auto"}}> 
                                      <div dangerouslySetInnerHTML={{ __html: this.state.roadmap }}></div>           
                                    </div>
                                    
                                </div>
                                
                                {/*<div className="d-flex flex-row" style={{marginTop:"20px", marginBottom:"20px"}}>
                                        <div style={{fontWeight:"bold"}}>Price :&nbsp;</div>
                                        <div>500 € </div>
                                </div>*/}
                                                                    
                                <div className='row text-white d-flex align-items-center'>
                                    <div style={{marginBottom:"-20px", position:"fixed"}}>
                                        <Button className="btn "style={{ marginLeft:"16px",marginTop:"40px"}} onClick={() => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'',  roadmap:'',  extensionimg: '',listimage:[]})} variant="primary">Close</Button>
                                        <Button className="btn btn-warning " style={{ marginLeft:"360px",marginTop:"40px"}} onClick={() => this.reservation(this.state.title)} variant="primary">Book it</Button>
                                    </div>
                                    
                                </div>

                                </div>

                        </div>    

                    </Modal.Body>
                    </Modal>
                </BrowserView>

                <MobileView >

                <Modal
                        
                      show={this.state.isModalVisible}
                      onHide={ () => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'',  roadmap:'',  extensionimg: '', listimage:[]})}
                      dialogClassName="modal-dialog-mobile"
                      aria-labelledby="example-custom-modal-styling-title" centered
                    >
                    
                    <Modal.Body>

                        <div className="modal-infotype">

                          {this.state.listimage.length>0 ?

                            <Carousel >

                            {this.state.listimage.map((lst) => {

                            return (

                                  <Carousel.Item key={lst.idimagestours} interval={3000}>
                                
                                    <img
                                      className="d-block w-100" style={{width:"100%",height:"40vh", marginTop:"0px", borderRadius:"10px"}}
                                      src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + lst.idimagestours + '.' + lst.extensionimage}
                                    />
                                                                                
                                  </Carousel.Item>

                              );
                            })} 

                            </Carousel>

                            :

                            <img
                              style={{width:"100%",height:"40vh", marginTop:"0px", borderRadius:"10px"}}
                              src={process.env.PUBLIC_URL + './images/tours/' + this.state.idtourselect + '.' + this.state.extensionimg}
                            />

                            }

                                <div style={{margin:"20px",overflowX:"auto", height:'220px', width:"40vh"}}>
                                    
                                    <div className="d-flex flex-column">
                                        <p style={{fontWeight:"bold", textAlign:'center',maxHeight:"6rem",overflowX:"auto"}}>{this.state.title}&nbsp;</p>
                                        
                                    </div>
                                    <p style={{height:"40vh",maxHeight:"6rem",overflowX:"auto"}}>{this.state.description}</p>
                                  
                                    <div>
                                      
                                      <div dangerouslySetInnerHTML={{ __html: this.state.roadmap }}></div> 
                                        
                                    </div>
                                
                                    {/*<div className="d-flex flex-row" style={{marginTop:"20px", marginBottom:"20px"}}>
                                        <div style={{fontWeight:"bold"}}>Price :&nbsp;</div>
                                        <div>500 € </div>    
                                    </div>*/}

                                </div>

                                <Button className="btn float-start" style={{marginTop:"20px"}} onClick={() => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'',  roadmap:'',  extensionimg: '', listimage:[]})} variant="primary">Close</Button>
                                <Button className="btn btn-warning float-end" style={{marginTop:"20px"}}  onClick={() => this.reservation(this.state.title)} variant="primary">Book it</Button>

                        </div>    

                    </Modal.Body>
                    </Modal>

                </MobileView>
                                        
                   
                </div>

                    
                    {this.state.scrollpage>200 ?

                        <Zoom>
                          <button className="bnttop" onClick={() => this.scrolltop()} style={{width:'50px', height:'50px', marginBottom:"70px",padding:"0%"}}><span><KeyboardDoubleArrowUpIcon /></span></button>
                        </Zoom>

                        :

                        null
                    
                    }
                    

                    {/** 
          
                    <div id="tours" >
                        
                        <Fade bottom>
                          <div className='align-items-center'>                         
                              <p style={{color:"black", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'20px'}}>Travel Tours</p>

                          </div>
                        </Fade>
                        

                        <BrowserView>
                          <div className='listedata'>
                            {this.state.touteslestours.map((tours) => {
                              return (

                                  <div >

      
                                      <Fade bottom>
                                        <div key={tours.idtours} className="cardlist" style={{}}>
                                          <div className="row">

                                            <div className="col">

                                                <img variant="top" src={process.env.PUBLIC_URL + './images/tours/' + tours.idtours + '.jpg'} style={{width:"24rem", height:"16rem", marginTop:"1rem", marginLeft:"1rem",resizeMode:"contain"}} className="rounded float-left" alt='Mada Photo Tours'/>

                                            </div>

                                            <div className="col" style={{width:"25rem", height:"18rem",maxHeight:"18rem"}}>

                                                    <p style={{marginTop:"1rem", fontSize:"1.5rem", fontWeight:"bold", textAlign:"center"}}>{tours.titletours}</p>
                                                    <p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"auto"}}>{tours.descriptiontours}</p>
                                                    
                                                    <div className='align-items-center'>
                                                        
                                                        <button className="buttondetails" style={{width:'100px', margin:"1rem",marginTop:"-1rem"}} onClick={() => this.selecttours(tours.idtours,tours.titletours,tours.descriptiontours,tours.roadmaptours,tours.extensionimage)} >ABOUT</button>
                                                        
                                                    </div>
                                            </div>

                                          </div>
                                        </div>
                                      </Fade>
          
                                                                    
                                  </div>

                                );
                            })}

                          </div>

                        </BrowserView>

                        <MobileView>
                          <div className='listedatamobile justify-content-center'>
                            {this.state.touteslestours.map((tours) => {
                              return (

                                  <div >

      
                                        <Fade bottom>
                                          <div key={tours.idtours} className="cardlistmobile" >
                                            <div className="column">

                                            

                                                  <img variant="top" src={process.env.PUBLIC_URL + './images/tours/' + tours.idtours + '.jpg'} style={{width:"90%", height:"16rem", margin:"1rem",resizeMode:"contain", borderRadius:"10px"}}  alt='Mada Photo Tours'/>

                                              

                                              <div style={{width:"100%", height:"18rem"}}>

                                                      <p style={{marginTop:"1rem", fontSize:"1.5rem", fontWeight:"bold", textAlign:"center"}}>{tours.titletours}</p>
                                                      <p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"auto"}}>{tours.descriptiontours}</p>
                                                      
                                                      <div className='align-items-center'>
                                                          
                                                          <button className="buttondetails" style={{width:'100px', margin:"1rem"}} onClick={() => this.selecttours(tours.idtours,tours.titletours,tours.descriptiontours,tours.roadmaptours,tours.extensionimage)} >ABOUT</button>
                                                          
                                                      </div>
                                              </div>

                                            </div>
                                          </div>
                                        </Fade>
          
                                                                    
                                  </div>

                                );
                            })}
                          </div>
                        </MobileView>
                    </div> 
                    */}

                    <div id="seo-exotic" className="listedata"> 

                      <header id="hero" className="data-seo">
                        <h1 style={{color:"#3498db"}}>Luxury Travel in Madagascar - Bespoke Wildlife, Birdwatching & Photography Tours</h1>

                        <p>Discover Madagascar through exclusive, tailor-made journeys designed for travelers seeking authenticity, comfort, and unique experiences.</p>
                        <p>From pristine rainforests to rare wildlife encounters, every trip is crafted to deliver unforgettable moments.</p>
                      </header>


                      <section id="why-madagascar" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Why Madagascar for Luxury Travel</h2>

                        <h3>A Unique and Untouched Destination</h3>
                        <p>
                          Madagascar is one of the last great natural sanctuaries on Earth, offering ecosystems found nowhere else in the world.
                        </p>

                        <h3>Exclusive Travel Experiences</h3>
                        <p>
                          Enjoy private, bespoke journeys designed for travelers who seek meaningful and personalized experiences.
                        </p>

                        <h3>Comfort Meets Authenticity</h3>
                        <p>
                          Luxury travel in Madagascar combines boutique accommodations, eco-lodges, and carefully curated experiences.
                        </p>
                      </section>


                      <section id="bespoke" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Bespoke Travel Experiences</h2>

                        <h3>Tailor-Made Itineraries</h3>
                        <p>
                          Every journey is custom-designed based on your preferences, travel style, and schedule.
                        </p>

                        <h3>Private Guided Tours</h3>
                        <p>
                          Explore Madagascar with expert local guides for a fully immersive and private experience.
                        </p>

                        <h3>Luxury and Comfort Focus</h3>
                        <p>
                          From transport to accommodation, every detail is handled for a seamless travel experience.
                        </p>
                      </section>


                      <section id="wildlife" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Wildlife Tours in Madagascar</h2>

                        <h3>Encounter Unique Species</h3>
                        <p>
                          Discover lemurs, chameleons, and rare species found only in Madagascar's unique ecosystems.
                        </p>

                        <h3>National Parks Exploration</h3>
                        <p>
                          Explore rainforests, dry forests, and protected reserves rich in biodiversity.
                        </p>

                        <h3>Responsible Eco-Tourism</h3>
                        <p>
                          All tours support conservation and sustainable tourism practices.
                        </p>
                      </section>


                      <section id="birdwatching" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Birdwatching & Birding Tours</h2>

                        <h3>A Birdwatcher's Paradise</h3>
                        <p>
                          Madagascar is home to many endemic bird species, making it a top destination for birding enthusiasts.
                        </p>

                        <h3>Expert-Guided Birding Trips</h3>
                        <p>
                          Professional guides help you locate and observe rare species in optimal conditions.
                        </p>

                        <h3>Seasonal Migration and Endemics</h3>
                        <p>
                          Experience both migratory and endemic bird species depending on the season.
                        </p>
                      </section>


                      <section id="photography" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Photography Tours in Madagascar</h2>

                        <h3>Capture Extraordinary Landscapes</h3>
                        <p>
                          From baobab avenues to tropical rainforests, Madagascar offers unique photography opportunities.
                        </p>

                        <h3>Wildlife Photography Expeditions</h3>
                        <p>
                          Get close to rare wildlife in natural environments with expert guidance.
                        </p>

                        <h3>Professional-Level Guidance</h3>
                        <p>
                          Improve your photography skills with structured, location-based shooting sessions.
                        </p>
                      </section>

                      <section id="experience" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Luxury & Experience Philosophy</h2>

                        <h3>Travel Beyond Expectations</h3>
                        <p>
                          Luxury is defined by exclusivity, personalization, and meaningful travel experiences.
                        </p>

                        <h3>Deep Cultural Immersion</h3>
                        <p>
                          Meet local communities and discover Malagasy traditions.
                        </p>

                        <h3>Sustainable Luxury Travel</h3>
                        <p>
                          We prioritize responsible tourism and environmental preservation.
                        </p>
                      </section>


                      <section id="audience" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Who This Experience Is For</h2>

                        <h3>Discerning Travelers</h3>
                        <p>
                          For travelers seeking privacy, quality, and unique destinations.
                        </p>

                        <h3>Wildlife Enthusiasts</h3>
                        <p>
                          Ideal for those passionate about nature and biodiversity.
                        </p>

                        <h3>Photographers & Creators</h3>
                        <p>
                          Perfect for capturing exceptional landscapes and wildlife imagery.
                        </p>
                      </section>


                      <section id="contact" className="card-exotic">
                        <h2 style={{color:"#3498db"}}>Plan Your Madagascar Journey</h2>

                        <h3>Start Your Bespoke Experience</h3>
                        <p>
                          Contact us to design your personalized luxury itinerary in Madagascar.
                        </p>

                        <h3>Flexible Travel Planning</h3>
                        <p>
                          Trips are adapted to your timing and preferences.
                        </p>
                      </section>    

                    </div>
                    
                    <div id="gallery">

                      <BrowserView>

                        {this.state.gallery.length > 0 ?

                            <div >  

                              <Zoom >
                                  <div className='align-items-center'>                         
                                      <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'30px'}}>Gallery</p>
                                    
                                  </div>
                                </Zoom>

                              <div  className="listedata">
                                {this.state.gallery.map((data_gallery) => {
                                    return (
                                        
                                      <div key={data_gallery.idgallery} className="gallery-image" style={{backgroundImage:`url(${process.env.PUBLIC_URL + data_gallery.original})` ,backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}} onMouseEnter={() => this.setState({ hoveredIdImage: data_gallery.idgallery,hoveredLinkImage: data_gallery.original })}>

                                        {parseInt(this.state.hoveredIdImage) === parseInt(data_gallery.idgallery) ?

                                          <div className="button_full_screen textombrenoir" onClick={() => this.setState({ Fullscreenview: true })} style={{zIndex:999999}}>
                                            
                                            <p style={{fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'-20px'}}>Full screen</p>

                                          </div>

                                          :

                                          null

                                        }

                                      </div>
                                                                      
                                    );
                                })}
                              </div>

                              {this.state.Fullscreenview === true?

                                <div
                                      className="modal-fullscreen"
                                      onClick={() => this.setState({ showModal: false })}
                                  >

                                    <div className="modal-close">
                                      <span style={{color:"red"}} onClick={() => this.setState({ Fullscreenview:false,hoveredIdImage: 0, hoveredLinkImage:'' })}><CloseIcon/></span>
                                    </div>
                                      <Zoom>
                                      <img
                                          src={this.state.hoveredLinkImage}
                                          alt=""
                                          style={{
                                              maxWidth: "95vw",
                                              maxHeight: "95vh",
                                              objectFit: "contain"
                                          }}
                                        
                                      />
                                      </Zoom>
                                  </div>
       
                                :

                                null

                              }

                            </div>

                            :

                            null
                        }

                      </BrowserView>


                      <MobileView>

                        {this.state.gallery.length > 0 ?

                            <div >  

                              <Zoom >
                                <div className='align-items-center'>                         
                                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'30px'}}>Gallery</p>
                                  
                                </div>
                              </Zoom>

                              <div style={{ display: 'flex', justifyContent: 'center' }}>

                                <Carousel style={{width:"90vw",height:"30vh"}}>
                              
                                  {this.state.gallery.map((data_gallery) => {
                                      return (

                                        <Carousel.Item key={data_gallery.idgallery} interval={3000}>
                                            
                                          <img
                                            style={{width:"90vw",height:"30vh", marginTop:"0px", borderRadius:"10px",}}
                                            src={process.env.PUBLIC_URL + data_gallery.original}
                                          />
                                                                                      
                                        </Carousel.Item>
          
                                                                                          
                                      );
                                  })}

                                </Carousel>

                              </div>
                            
                            </div>

                            :

                            null

                        }

                      </MobileView>

                      


                       {/*

                        <ImageGallery
                              items={this.state.gallery}
                              autoPlay={true}
                              slideDuration={1000}                                    
                              slideInterval={5000}
                              showBullets={true}
                              showIndex={true}
                              showThumbnails={true}
                              lazyLoad={true}
                              showPlayButton={false}
                              thumbnailClass ={{backgroundColor:"white"}}
                                                        
                          />

                        */}

                    

                    </div>

                    {/*
                    <div id="about">
                  
                      <BrowserView>

                        <div id="Aboutus" style={{height:"100vh", backgroundImage:`url(${Aboutus_background})` ,backgroundSize: '100%', backgroundRepeat: 'no-repeat'}}>

                          <div className="d-flex flex-row " style={{zIndex:99999}}>

                            <Fade left>
                              <div className='button_aboutus' onClick={() => this.navigateto("/Aboutus")}>

                                  <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>About us</p>
                                
                              </div>
                            </Fade>

                            <Fade right>
                              <div className='button_aboutus' onClick={() => this.navigateto("/Services")}>
                                
                                  <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'0px'}}>Our services</p>
                                                          
                              </div>
                            </Fade>

                          </div>

                        </div>

                      </BrowserView>

                      <MobileView>

                        <div id="Aboutus" style={{height:"30vh",backgroundImage:`url(${Aboutus_background})` ,backgroundSize: '100%', backgroundRepeat: 'no-repeat'}}>

                          <div className="d-flex flex-row " style={{height:"30vh",zIndex:99999}}>

                              <Fade left>
                                <div className='button_aboutus_mobile' onClick={() => this.navigateto("/Aboutus")} >

                                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"20px", textAlign:'center', marginTop:'0px'}}>About us</p>
                                  
                                </div>
                              </Fade>

                              <Fade right>

                                <div className='button_aboutus_mobile' onClick={() => this.navigateto("/Services")}>
                                  
                                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"20px", textAlign:'center', marginTop:'0px'}}>Our services</p>
                                                            
                                </div>
                              </Fade>

                          </div>

                      </div>


                      </MobileView>

                    </div>

                    */}

                     <Fade bottom>
                      <div className='align-items-center'>                         
                          <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'30px'}}>Movie</p>
                      </div>
                    </Fade>
                    
                    <BrowserView>
                      <div className='d-flex align-items-center justify-content-center'>       
                          <ReactPlayer  style={{margin:"20px", width:"60%", height:"80vh",borderRadius: '10px',  overflow: 'hidden'}}
                            src='https://www.youtube.com/watch?v=xTe4j7126l4'
                          />   
                      </div>
                    </BrowserView> 

                    <MobileView>
                      <div className='d-flex align-items-center justify-content-center'>       
                        <ReactPlayer  style={{margin:"20px", width:"60%", height:"30vh",borderRadius: '10px',  overflow: 'hidden'}}
                          src='https://www.youtube.com/watch?v=xTe4j7126l4'
                        />
                      </div>
                    </MobileView>  

                    {this.state.allopinionuser.length>0 ?

                      <div id="opinion" style={{marginBottom:isBrowser?"20px":"20px"}}>
                                              
                      <Fade bottom>
                        <div className='align-items-center'>                         
                            <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:isBrowser?'30px':'20px'}}>Opinion</p>

                        </div>
                      </Fade>


                      <BrowserView>
                        <div className='listedata'>
                          {this.state.allopinionuser.map((opinion) => {
                            return (

                                <div >


                                    <Fade bottom>

                                      <div key={opinion.idutilisateur} className="cardlistopinion" style={{padding:'20px', width:'500px', height:'auto'}}>
                                        <p style={{fontSize:'1.5rem',fontWeight:'bold'}}>{opinion.prenomutilisateur} {opinion.nomutilisateur}</p>

                                        <div className="form-group" style={{margin:'10px'}}>
                                          <Rating
                                            onPointerMove={onPointerMove}
                                            initialValue={opinion.avis}
                                            readonly={true}
                                          />
                                        </div>

                                        <p>{opinion.descriptionavis}</p>

                                      </div>

                                    </Fade>
                                                
                                </div>

                              );
                          })}

                          <div className="cardlistopinion" style={{padding:'20px', width:'500px', height:'auto'}} onClick={ () => this.setState({ismodalinscription:true, nom:"", prenoms:"", mail:"",ratingvalue:5})}>
                            <p style={{fontSize:'1.5rem',fontWeight:'bold', textAlign:"center"}}>Click here to add your opinion</p>
                          </div>

                        </div>

                      </BrowserView>

                      <MobileView>

                        <div className='listedatamobile justify-content-center'>
                          {this.state.allopinionuser.map((opinion) => {
                            return (

                                <div >


                                    <Fade bottom>

                                      <div key={opinion.idutilisateur} className="cardlistmobile" style={{padding:'20px',  height:'auto'}} onClick={ () => this.setState({ismodalinscription:true, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})}>
                                        <p style={{fontSize:'1.5rem',fontWeight:'bold'}}>{opinion.prenomutilisateur} {opinion.nomutilisateur}</p>

                                        <div className="form-group" style={{margin:'10px'}}>
                                          <Rating
                                            onPointerMove={onPointerMove}
                                            initialValue={opinion.avis}
                                            readonly={true}
                                          />
                                        </div>

                                        <p>{opinion.descriptionavis}</p>

                                      </div>
                                      
                                    </Fade>
                                                
                                </div>

                              );
                          })}

                          <div className="cardlistmobile" style={{padding:'20px', height:'auto'}} onClick={ () => this.setState({ismodalinscription:true, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})}>
                            <p style={{fontSize:'1.5rem',fontWeight:'bold', textAlign:"center"}}>Click here to add your opinion</p>
                          </div>

                        </div>
                      </MobileView>
                      </div> 

                      :

                      null

                      }

                      {this.state.ismodalinscription == true?
                      
                          <Modal
                          
                            show={this.state.ismodalinscription}
                            onHide={ () => this.setState({ismodalinscription:false, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})}
                            dialogClassName="modal-dialog"
                            aria-labelledby="example-custom-modal-styling-title" centered
                            >
      
                          <Modal.Body>
                                      
                                                    
                          <div style={{marginRight:"10px"}}>
      
                            <BrowserView>
      
                            <Container>
                              <Row>
                                <Col>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Last name</label>
                                    <input type="text" className="form-control" value={this.state.nom} onChange={(e) => this.setState({ nom: e.target.value})} />
                                  </div>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>First name</label>
                                    <input type="text" className="form-control" value={this.state.prenoms} onChange={(e) => this.setState({ prenoms: e.target.value})} />
                                  </div>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Email *</label>
                                    <input type="email" className="form-control" aria-describedby="emailHelp" value={this.state.mail} onChange={(e) => this.setState({ mail: e.target.value})} />
                                  </div>   
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Password *</label>
                                    <input type="password" className="form-control" value={this.state.motdepasse} onChange={(e) => this.setState({ motdepasse: e.target.value})} />
                                  </div>

                                  <div className="form-group" style={{margin:'10px'}}>
                                    <Rating
                                      onPointerMove={onPointerMove}
                                      initialValue={this.state.ratingvalue}
                                    />
                                  </div>
        
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Your opinion</label>
                                    <Form.Control  size="sl" as="textarea" rows={4} placeholder="Your opinion about exotic Madagascar ..." ref="avisdescription" value={this.state.avisdescription} onChange={(e) => this.setState({ avisdescription: e.target.value})} />
                                  </div>
                                
                                </Col>
      
                              
                              </Row>
                            </Container>
      
                            </BrowserView>
      
                            <MobileView>
                                      
                              <div className="form-group" style={{margin:'10px'}}>
                                  <label>Last name</label>
                                  <input type="text" className="form-control" value={this.state.nom} onChange={(e) => this.setState({ nom: e.target.value})} />
                                </div>
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>First name</label>
                                  <input type="text" className="form-control" value={this.state.prenoms} onChange={(e) => this.setState({ prenoms: e.target.value})} />
                                </div>
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Email *</label>
                                  <input type="email" className="form-control" aria-describedby="emailHelp" value={this.state.mail} onChange={(e) => this.setState({ mail: e.target.value})} />
                                </div>   
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Password *</label>
                                  <input type="password" className="form-control" value={this.state.motdepasse} onChange={(e) => this.setState({ motdepasse: e.target.value})} />
                                </div>
                                <div className="form-group" style={{margin:'10px'}}>
                                  <Rating
                                    onPointerMove={onPointerMove}
                                    initialValue={this.state.ratingvalue}
                                  />
                                </div>

                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Your opinion</label>
                                  <Form.Control  size="sl" as="textarea" rows={4} placeholder="Your opinion about exotic Madagascar ..." ref="avisdescription" value={this.state.avisdescription} onChange={(e) => this.setState({ avisdescription: e.target.value})} />
                                </div>
      
                            </MobileView>
                                                                        
                            <div className="d-flex justify-content-center">
                                <Button className="btn btn-danger"style={{ margin:"10px", width:'150px', marginRight:'50px'}} onClick={ () => this.setState({ismodalinscription:false, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})} variant="primary">Close</Button>
                                <Button className="btn bntsign" style={{ margin:"10px",right: 0, width:'150px',backgroundColor: "#3498db",border: 0,}} onClick={() => this.addopinion()} >Add opinion</Button>   
                            </div>
      
                            </div>
                            
                          </Modal.Body>
                          </Modal>
      
                        
                          :
      
                          null
      
                        }

                    <BrowserView>

                      <Fade Zoom>
                      <div id="contact" className="justify-content-center footer" >

                        <div className="row justify-content-center" style={{paddingTop:"20px"}}>
                          <img src={ATTAMember_opt2} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                          <img src={ATTAMember_opt3} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                        </div>

                        <div className="d-flex flex-row justify-content-center" style={{marginTop:"20px"}}>

                              <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:20}}/></a>

                              <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10}}/></a>

                              <a href="https://www.youtube.com/@Exotic-Madagascar" target="_blank"><YouTubeIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginLeft:20}}/></a>
                        
                        </div>

                        <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                            <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginBottom:10, marginRight:20}}/></a>
                            <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                        </div>

                        <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                            <a href="tel:+261340963076" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/>+261 34 09 630 76</a>
                        </div>

                        <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                            <span style={{fontSize:'20px' , color: 'white', marginBottom:20}}>Antananarivo 101</span>
                        </div>

                        <div className="text-center">
                            <div className="py-1">

                                <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                  Copyright {new Date().getFullYear()} Exotic Madagascar. All rights reserved.
                                </p>
                                                                                  
                            </div>
                        </div>

                    </div>
                    </Fade>

                         {/*

                        <div className="container">

                           

                        <div className="container">
                          <div className="row">
                            <Fade left>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Contact</p>
                              
                             
                              <div className="contactlist'">  
                                  <a href="tel:+000000000" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank"></a>
                              </div>
                              

                              <div className="contactlist'">  
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                              </div>
                              
                             
                              <div className="contactlist'">  
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank" rel="noopener noreferrer"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank" rel="noopener noreferrer">Mail to the guide</a>
                              </div>
                              
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><SendIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank">Antananarivo 101</a>
                              </div>

                            </div>
                            </Fade>

                            <Fade right>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Support</p>
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>
                            </div>
                            </Fade>
                            
                          </div>

                        </div>

                          <Zoom>

                            <div className="row">
                                <div className="text-center">
                                    
                                    <div className="py-1">
                                        <a href="https://web.facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', margin:10}}/></a>
                                        <a href="https://linkedin.com/in/exoticmadagascar" target="_blank" ><LinkedInIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                        <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center">
                                <div className="py-1">

                                    <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                      Copyright &copy; {new Date().getFullYear()} Tous les droits réservés à Exotic Madagascar.
                                    </p>
                                                                                      
                                </div>
                            </div>

                          </Zoom>

                        </div>

                        </div>

                        */}

                    </BrowserView>

                    <MobileView>

                      <Fade Zoom>

                        <div id="contact" className="justify-content-center footer">

                          <div className="d-flex flex-column align-items-center justify-content-center" style={{paddingTop:"40px"}}>
                            <img src={ATTAMember_opt2} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                            <img src={ATTAMember_opt3} alt="Exotic Madagascar"  style={{width:"250px", height:"250px", marginTop:"40px"}}/>
                          </div>

                          <div className="d-flex flex-row justify-content-center" style={{marginTop:"20px"}}>

                            <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:20}}/></a>

                            <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10}}/></a>

                            <a href="https://www.youtube.com/@Exotic-Madagascar" target="_blank"><YouTubeIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginLeft:20}}/></a>
                      
                          </div>

                           <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginBottom:10, marginRight:20}}/></a>
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="tel:+261340963076" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/>+261 34 09 630 76</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <span style={{fontSize:isBrowser?"20px":"20px" , color: 'white', marginBottom:20}}>Antananarivo 101</span>
                          </div>

                          <div className="text-center">
                              <div className="py-1">

                                  <p className="textombrenoir" style={{ color:'white',fontSize:isBrowser?"20px":"14px"}}>
                                    Copyright {new Date().getFullYear()} Exotic Madagascar. All rights reserved.
                                  </p>
                                                                                    
                              </div>
                          </div>

                        </div>

                    </Fade>

                    {/* 
                      <div id="contact" className="justify-content-center footer">

                      <div id="contact" className="justify-content-center footer">

                          <div className="row justify-content-center" style={{marginTop:"-40px"}}>
                            <img src={ATTAMember_opt2} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                            <img src={ATTAMember_opt3} alt="Exotic Madagascar"  style={{width:"250px", height:"250px", marginTop:"40px"}}/>
                          </div>

                          <div className="d-flex flex-row justify-content-center" style={{marginTop:"20px"}}>

                                <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:20}}/></a>

                                <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10}}/></a>

                                <a href="https://www.youtube.com/@Exotic-Madagascar" target="_blank"><YouTubeIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginLeft:20}}/></a>
                          
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginBottom:10, marginRight:20}}/></a>
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="tel:+261340963076" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/>+261340963076</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <span style={{fontSize:isBrowser?"20px":"20px" , color: 'white', marginBottom:20}}>Antananarivo 101</span>
                          </div>

                          <div className="text-center">
                              <div className="py-1">

                                  <p className="textombrenoir" style={{ color:'white',fontSize:isBrowser?"20px":"14px"}}>
                                    Copyright {new Date().getFullYear()} Exotic Madagascar. All rights reserved.
                                  </p>
                                                                                    
                              </div>
                          </div>

                      </div>

                        <div className="container">

                        <div className="container">
                          <div className="column">
                            <Fade left>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Contact</p>
                              
                              <div className="contactlist'">  
                                  <a href="tel:+000000000" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank"></a>
                              </div>
                             

                              <div className="contactlist'">  
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                              </div>

                              {/*
                              <div className="contactlist'">  
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank">Mail to the guide</a>
                              </div>
                              
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><SendIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank">Antananarivo 101</a>
                              </div>
                              
                            </div>
                            </Fade>

                            <Fade right>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Support</p>
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>
                            </div>
                            </Fade>
                            
                          </div>

                        </div>

                          <Zoom>

                            <div className="row">
                                <div className="text-center">
                                    
                                    <div className="py-1">
                                        <a href="https://web.facebook.com/theharmelsmadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', margin:10}}/></a>
                                        <a href="https://linkedin.com/in/madaphototours" target="_blank" ><LinkedInIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                        <a href="https://youtube.com/user/madaphototours" target="_blank"><YouTubeIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center">
                                <div className="py-1">

                                    <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                      Copyright &copy; {new Date().getFullYear()} Tous les droits réservés à Exotic Madagascar.
                                    </p>
                                                                                      
                                </div>
                            </div>

                          </Zoom>

                        </div>

                        </div>

                        */}


                    </MobileView>
                   

              </div>
        );
      }
  
}

export default Accueil;
